import React from "react";
import Helmet from "react-helmet";
import UserInfo from "../components/UserInfo/UserInfo";
import Disqus from "../components/Disqus/Disqus";
import PostTags from "../components/PostTags/PostTags";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import config from "../../data/SiteConfig";
import "./b16-tomorrow-dark.css";
import styles from "./post.module.scss";
import HeaderPage from "../components/Header/HeaderPage";
import Header from "../components/Header/Header";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import Link from "gatsby-link";
import _ from "lodash";

export default class PostTemplate extends React.Component {
  render() {
    const { slug } = this.props.pathContext;
    const postNode = this.props.data.markdownRemark;
    const post = postNode.frontmatter;
    if (!post.id && typeof this.props.pathContext.slug != 'undefined') {
      post.id = slug;
    }
    if (!post.id) {
      post.category_id = config.postDefaultCategoryID;
    }

    let title = post.title;
    let description = "";
    let picture = post.cover;

    return (
      <div className={styles.post}  itemScope itemType="http://schema.org/Article">
        <Helmet>
          <title>{`${post.title} | ${config.siteTitle}`}</title>
        </Helmet>
        <SEO postPath={slug} postNode={postNode} postSEO />
        <Menu />
        <Header />
        <HeaderPage title={title} description={description} picture={picture}/>
        <article className="container row-bottom-padded-md row-top-padded-md">
  
          <div className={styles.postdetails}>
            <span className="date">{post.date.substr(6,2)+"/"+post.date.substr(4,2)+"/"+post.date.substr(0,4)}</span>&nbsp;&middot;&nbsp;
            <Link
                key={post.category}
                style={{ textDecoration: "none" }}
                to={`/categories/${_.kebabCase(post.category)}`}
                title={ `Catégorie ${post.category}`}
              >
              &nbsp;{post.category}
              </Link>
          </div>

          <div  itemProp="articleBody" dangerouslySetInnerHTML={{ __html: postNode.html }} />
          <div className={styles.postmeta}>
            <PostTags tags={post.tags} />
          </div>
        </article>
        <SocialLinks postPath={slug} postNode={postNode} />
        <Footer />
      </div>
    );
  }
}

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      excerpt
      frontmatter {
        title
        cover
        date
        category
        tags
      }
      fields {
        slug
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/post.jsx